var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Additional Cost (Rs)",
                    "label-for": "cost",
                    "label-cols-md": "4",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "cost",
                      type: "number",
                      placeholder: "Rs 6000",
                    },
                    on: { change: _vm.calculatePrice },
                    model: {
                      value: _vm.price.additionalCost,
                      callback: function ($$v) {
                        _vm.$set(_vm.price, "additionalCost", $$v)
                      },
                      expression: "price.additionalCost",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Previous Selling Price (Rs)",
                    "label-for": "price",
                    "label-cols-md": "4",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "price",
                      type: "number",
                      placeholder: "Rs 8280",
                      readonly: "",
                    },
                    model: {
                      value: _vm.PrevioussalePrice,
                      callback: function ($$v) {
                        _vm.PrevioussalePrice = $$v
                      },
                      expression: "PrevioussalePrice",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "New Selling Price (Rs)",
                    "label-for": "price",
                    "label-cols-md": "4",
                  },
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "price",
                      type: "number",
                      placeholder: "Rs 8280",
                      readonly: "",
                    },
                    model: {
                      value: _vm.productID.salePrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.productID, "salePrice", $$v)
                      },
                      expression: "productID.salePrice",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }